<button mat-icon-button (click)="copyToClipboard()" matTooltip="Kopiera">
    <mat-icon fontIcon="content_copy"></mat-icon>
</button>